import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from "moment";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Button from "@material-ui/core/Button/Button";
import ClearAll from "@material-ui/icons/ClearAll";
import FilterListIcon from "@material-ui/icons/FilterList";
import {MOBILE_TABLE_VIEW_AMOUNT} from "../../helpers/constants";
import TablePagination from "@material-ui/core/TablePagination";
import {getStoreType, scrollToElement} from "../../helpers/functions";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions";

const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  summaryContent: {
    flexWrap: 'wrap'
  },
});

class DepartmentScoresListMobile extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      expanded: null,
    };

    this.storesMobileListRef = React.createRef();

  }

  componentDidMount(){
    this.props._changeLocalState({
      key: 'rowsPerPage',
      value: MOBILE_TABLE_VIEW_AMOUNT
    })
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    const { classes, stores, handleChangePage, handleChangeRowsPerPage, page, rowsPerPage} = this.props;
    const { expanded } = this.state;

    return (
      <div className={classes.root} ref={this.storesMobileListRef}>
        <Typography variant="h6" id="tableTitle">
          {`Pending stores to score (Department: ${this.props.department.name})`}
        </Typography>
        <div className={'mb-3'}>
          <Button color="secondary" style={{paddingLeft: 0}} onClick={this.props.clearFilters}>
            Clear filters
            <ClearAll className={'ml-1'}/>
          </Button>
          <Button color="primary"  style={{paddingLeft: 0}} onClick={this.props.openFilterModal}>
            Filter list
            <FilterListIcon className={'ml-1'}/>
          </Button>
        </div>
        {
          stores
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map(store => {
              const totalStoreCriteria = this.props._getTotalStoreCriteria(store);
              return (
                <ExpansionPanel
                  key={store.id}
                  expanded={expanded === store.id}
                  onChange={this.handleChange(store.id)}
                >
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} classes={{content: classes.summaryContent}}>
                    <Typography className={classes.heading}>{store.name}</Typography>
                    <Typography className={classes.secondaryHeading}>
                      {moment(store.openDate).format('DD/MM/YYYY HH:mm:ss')}
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Table >
                      <TableBody>
                        <TableRow >
                          <TableCell  component="th" scope="row">{'Id'}</TableCell>
                          <TableCell>{store.id}</TableCell>
                        </TableRow>
                        <TableRow >
                          <TableCell  component="th" scope="row">{'Scored Criteria #'}</TableCell>
                          <TableCell>
                            {`${store.totalScoredCriteria} / ${totalStoreCriteria}`}
                          </TableCell>
                        </TableRow>
                        <TableRow >
                          <TableCell  component="th" scope="row">{'Erp id'}</TableCell>
                          <TableCell>{store.dwId}</TableCell>
                        </TableRow>
                        <TableRow >
                          <TableCell  component="th" scope="row">{'City'}</TableCell>
                          <TableCell>{store.city}</TableCell>
                        </TableRow>
                        <TableRow >
                          <TableCell  component="th" scope="row">{'Entersoft code'}</TableCell>
                          <TableCell>{store.enterSoftCode}</TableCell>
                        </TableRow>
                        <TableRow >
                          <TableCell  component="th" scope="row">{'Type'}</TableCell>
                          <TableCell>{getStoreType(store)}</TableCell>
                        </TableRow>
                        <TableRow >
                          <TableCell  component="th" scope="row">{'Open Date'}</TableCell>
                          <TableCell>
                            {moment(store.openDate).isValid()?moment(store.openDate).format('DD/MM/YYYY HH:mm:ss'):''}
                          </TableCell>
                        </TableRow>
                        <TableRow >
                          <TableCell  component="th" scope="row">{'Created Date'}</TableCell>
                          <TableCell>
                            {moment(store.createdDate).isValid()?moment(store.createdDate).format('DD/MM/YYYY HH:mm:ss'):''}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </ExpansionPanelDetails>
                  <ExpansionPanelActions>
                    <Button
                      size="small"
                      color="primary"
                      onClick={() => this.props.openPendingCriteriaModal(store)}
                    >
                      {'Pending criteria to score'}
                    </Button>
                  </ExpansionPanelActions>
                </ExpansionPanel>
              )
            })
        }
        <TablePagination
          classes={
            {
              root: classes.pager,
              toolbar: classes.pagerToolbar
            }
          }
          rowsPerPageOptions={[]}
          labelRowsPerPage={''}
          component="div"
          count={stores.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'Previous Page',
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page',
          }}
          onChangePage={(evt, page) => {
            scrollToElement(this.storesMobileListRef.current);
            handleChangePage(evt, page);
          }}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </div>
    );
  }
}

DepartmentScoresListMobile.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DepartmentScoresListMobile);



// WEBPACK FOOTER //
// ./src/components/department/departmentScoresListMobileView.js